import './ProfileHeader.scss';
import React from 'react';
import { useIntl } from 'react-intl';
import { LayoutBreadcrumbItem } from 'src/modules/common/components/LayoutBreacrumbItem';
import { LayoutBreadcrumb } from 'src/modules/common/components/LayoutBreadcrumb';

type Props = {
  title: string;
};

export const ProfileHeader = ({ title }: Props): React.ReactElement => {
  const intl = useIntl();

  return (
    <header className="bp-profile-header">
      <div className="bp-profile-header__content">
        <LayoutBreadcrumb>
          <LayoutBreadcrumbItem to="/projects">
            {intl.formatMessage({ id: 'profile/header/breadcrumbs/project' })}
          </LayoutBreadcrumbItem>
        </LayoutBreadcrumb>

        <h1 className="bp-profile-header__title">{title}</h1>
      </div>
    </header>
  );
};
